import Debug from "debug";

import { ACTIONS } from "./constants";
import {
  PayloadChannelGetOne,
  ActionChannelGetOne,
  ActionViewerBroadcastSettings,
  PayloadViewerBroadcastSettings,
  ActionViewerStopPoll,
  ActionViewerStartPoll,
  PayloadViewerCount,
  ActionViewerCountStartPoll,
  ActionViewerCountStopPoll,
  ActionViewerStreamState,
  StreamState,
  ActionViewerReaction,
  PayloadViewerReaction,
  ActionViewerVideoReaction,
  PayloadViewerVideoReaction,
  PayloadViewerVerifyPassword,
  ActionViewerVerifyPassword,
  ActionViewerRefreshToken,
  ActionViewerAuthRemove,
  PayloadViewerAuth,
  ActionViewerAuthRequest,
} from "../types";
import { ScreenCloudLogger } from "../ScreenCloudReactApp";

const debug = Debug("broadcast:actions:viewer");

export const getViewerChannel = (
  payload: PayloadChannelGetOne,
  logger?: ScreenCloudLogger
): ActionChannelGetOne => {
  debug("getChannel", payload);
  return {
    type: ACTIONS.VIEWER_GET_CHANNEL_REQUEST,
    payload,
    logger,
  };
};

export const getViewerBroadcastSettings = (
  payload: PayloadViewerBroadcastSettings
): ActionViewerBroadcastSettings => {
  debug("getBroadcastSettings", payload);
  return {
    type: ACTIONS.VIEWER_GET_BROADCAST_SETTINGS_REQUEST,
    payload,
  };
};

export const getViewerPlaybackUrl = (
  payload: PayloadViewerBroadcastSettings
): ActionViewerBroadcastSettings => {
  debug("getViewerPlaybackUrl", payload);
  return {
    type: ACTIONS.VIEWER_GET_PLAYBACK_URL_REQUEST,
    payload,
  };
};

export const startViewerStreamStatePolling = (
  payload: PayloadChannelGetOne
): ActionViewerStartPoll => {
  debug("startViewerStreamStatePolling", payload);
  return {
    type: ACTIONS.VIEWER_STREAM_STATE_POLLING_START,
    payload,
  };
};

export const endViewerStreamStatePolling = (): ActionViewerStopPoll => {
  debug("endViewerStreamStatePolling");
  return {
    type: ACTIONS.VIEWER_STREAM_STATE_POLLING_END,
    payload: null,
  };
};

export const setViewerStreamState = (
  payload: StreamState
): ActionViewerStreamState => {
  debug("setViewerStreamState");
  return {
    type: ACTIONS.VIEWER_STREAM_STATE_SET,
    payload,
  };
};

export const startViewerCountPolling = (
  payload: PayloadViewerCount,
  logger?: ScreenCloudLogger
): ActionViewerCountStartPoll => {
  debug("startViewerCountPolling", payload);
  return {
    type: ACTIONS.VIEWER_COUNT_POLLING_START,
    payload,
    logger,
  };
};

export const endViewerCountPolling = (): ActionViewerCountStopPoll => {
  debug("endViewerCountPolling");
  return {
    type: ACTIONS.VIEWER_COUNT_POLLING_END,
    payload: null,
  };
};

export const reactToStream = (
  payload: PayloadViewerReaction
): ActionViewerReaction => {
  debug("reactToStream", payload);
  return {
    type: ACTIONS.VIEWER_REACT_TO_STREAM_REQUEST,
    payload,
  };
};

export const addReaction = (
  payload: PayloadViewerVideoReaction
): ActionViewerVideoReaction => {
  debug("addReaction", payload);
  return {
    type: ACTIONS.VIEWER_REACT_TO_STREAM_REACTION,
    payload,
  };
};

export const removeReaction = (
  payload: PayloadViewerVideoReaction
): ActionViewerVideoReaction => {
  debug("removeReaction", payload);
  return {
    type: ACTIONS.VIEWER_REMOVE_STREAM_REACTION,
    payload,
  };
};

export const verifyPassword = (
  payload: PayloadViewerVerifyPassword,
  logger?: (message: string, error?: unknown) => void
): ActionViewerVerifyPassword => {
  debug("verifyPassword", payload);
  return {
    type: ACTIONS.VIEWER_VERIFY_PASSWORD_REQUEST,
    payload,
  };
};

export const refreshTokenPollingStart = (
  logger?: ScreenCloudLogger
): ActionViewerRefreshToken => {
  return {
    type: ACTIONS.VIEWER_REFRESH_TOKEN_POLLING_START,
    payload: null,
    logger,
  };
};

export const refreshTokenPollingEnd = (
  logger?: ScreenCloudLogger
): ActionViewerRefreshToken => {
  debug("refreshTokenPollingEnd");
  return {
    type: ACTIONS.VIEWER_REFRESH_TOKEN_POLLING_END,
    payload: null,
    logger,
  };
};

export const getViewerAuth = (
  payload: PayloadViewerAuth
): ActionViewerAuthRequest => {
  debug("getEditorAuth", payload);
  return {
    type: ACTIONS.VIEWER_AUTH_REQUEST,
    payload,
  };
};

export const removeViewerAuth = (): ActionViewerAuthRemove => {
  debug("removeViewerAuth");
  return {
    type: ACTIONS.VIEWER_AUTH_REMOVE,
    payload: null,
  };
};
